// extracted by mini-css-extract-plugin
module.exports = {"GoogleTranslateElement":"Translate_GoogleTranslateElement__2FlMT","GoogleTranslateInfo":"Translate_GoogleTranslateInfo__C7iBf","Cross":"Translate_Cross__2QIC5"};